import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { getBrandVaultProject } from './utils';

const selectBrandState = (state: RootState) => state.brand;

export const selectBrandCode = createSelector(
  [selectBrandState],
  (brandState) => brandState.code,
);

export const selectBrandName = createSelector(
  [selectBrandState],
  (brandState) => brandState.name,
);

export const selectCompanyDetails = createSelector(
  [selectBrandState],
  (brandState) => brandState.companyDetails,
);

export const selectIsCompanyDetailsExist = createSelector(
  [selectCompanyDetails],
  (companyDetails) => !!companyDetails.id,
);

export const selectBrandCustomerServicePhone = createSelector(
  [selectBrandState, selectCompanyDetails],
  (brandState, companyDetails) => {
    if (companyDetails?.type?.toLowerCase() === 'breach') {
      return (
        companyDetails?.altCustomerServiceNumber ||
        companyDetails?.customerCareNumber ||
        brandState.customerServicePhone ||
        ''
      );
    }

    return brandState.customerServicePhone || '';
  },
);

export const selectIsBrandDetailsExist = createSelector(
  [selectBrandState],
  (brandState) => !!brandState.id,
);

export const selectBrandVaultProject = createSelector(
  [selectBrandCode],
  getBrandVaultProject,
);

export const selectBrandLogoUrl = createSelector(
  [selectBrandState],
  (brandState) => brandState.logoUrl,
);

export const selectBrandFaviconUrl = createSelector(
  [selectBrandState],
  (brandState) => brandState.faviconUrl,
);

export const selectBrandCustomerServiceEmail = createSelector(
  [selectBrandState],
  (brandState) => brandState.customerServiceEmail,
);
